import React, { FC } from 'react';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import partition from 'lodash/partition';

import { INoteDTO } from 'src/api/dtos';
import { ChatSquareIcon } from 'src/shared/components';
import { useTranslate } from 'src/shared/providers';

export interface Props {
  employeeId: number | undefined;
  notes: INoteDTO[];
}

export const AbsenceNotesTooltip: FC<Props> = ({ employeeId, notes }) => {
  const { t } = useTranslate();

  if (!notes.length) {
    return null;
  }

  const [employeeNotes, approverNotes] = partition(notes, (note) => note.employeeId === employeeId);

  return (
    <Tooltip
      title={
        <Stack direction="column" spacing={1}>
          {!!employeeNotes.length && (
            <div>
              <Typography fontSize="0.75rem" fontWeight={500}>
                {t('absences.note')}:
              </Typography>
              <Typography fontSize="0.75rem">{employeeNotes.map((note) => note.content).join(', ')}</Typography>
            </div>
          )}
          {!!approverNotes.length && (
            <div>
              <Typography fontSize="0.75rem" fontWeight={500}>
                {t('absences.approverNote')}:
              </Typography>
              <Typography fontSize="0.75rem">{approverNotes.map((note) => note.content).join(', ')}</Typography>
            </div>
          )}
        </Stack>
      }
    >
      <IconButton sx={{ p: 0, me: 0.5 }} size="small" color="inherit">
        <ChatSquareIcon size={12} />
      </IconButton>
    </Tooltip>
  );
};
